// src/components/ProductsPage/packaging/PackagingCard.jsx
import React from "react";
import Button from "../../UI/Button";

const fmt = (v, digits = 2) =>
  Number(v || 0).toLocaleString("ru-RU", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

function BoxIcon() {
  return (
    <svg viewBox="0 0 64 64" className="w-16 h-16">
      <polygon points="8,20 32,8 56,20 32,32" fill="#93c5fd" stroke="#1e40af" strokeWidth="1.2" />
      <polygon points="8,20 32,32 32,56 8,44" fill="#3b82f6" stroke="#1e40af" strokeWidth="1.2" />
      <polygon points="32,32 56,20 56,44 32,56" fill="#2563eb" stroke="#1e40af" strokeWidth="1.2" />
    </svg>
  );
}

export default function PackagingCard({ pkg, onEdit, onDelete }) {
  const gross = Number(pkg.gross_weight || 0);
  const net = Number(pkg.net_weight || 0);
  const tare = Math.max(gross - net, 0);
  const volume = Number(pkg.volume_m3 || 0);
  const density = Number(pkg.density_kg_m3 || 0);

  return (
    <div className="border rounded-xl bg-white p-4 shadow-sm flex gap-4">
      <div className="shrink-0 flex flex-col items-center">
        <BoxIcon />
        <div className="text-xs text-gray-500 mt-1 text-center leading-tight">
          {pkg.length}×{pkg.width}×{pkg.height} см
        </div>
      </div>

      <div className="flex-1 min-w-0">
        <h3 className="font-semibold text-base truncate">
          {pkg.name || "Без названия"}
        </h3>
        <div className="text-xs text-gray-500 mt-0.5">
          Класс экосбора: <b>{pkg.eco_fee_class ?? 0}</b>
        </div>

        <div className="grid grid-cols-2 gap-2 mt-3 text-sm">
          <div>
            <div className="text-xs text-gray-500">В упаковке</div>
            <div className="font-semibold">{pkg.quantity} шт</div>
          </div>
          <div>
            <div className="text-xs text-gray-500">Объём</div>
            <div className="font-semibold">{fmt(volume, 4)} м³</div>
          </div>
          <div>
            <div className="text-xs text-gray-500">Нетто / Брутто</div>
            <div className="font-semibold">
              {fmt(net, 3)} / {fmt(gross, 3)} кг
            </div>
          </div>
          <div>
            <div className="text-xs text-gray-500">Тара</div>
            <div className="font-semibold">{fmt(tare, 3)} кг</div>
          </div>
          <div className="col-span-2">
            <div className="text-xs text-gray-500">Плотность</div>
            <div className="font-semibold">{fmt(density, 1)} кг/м³</div>
          </div>
        </div>

        {pkg.comment && (
          <p className="text-xs text-gray-600 mt-2 whitespace-pre-wrap">
            {pkg.comment}
          </p>
        )}

        <div className="flex gap-2 mt-3">
          <Button variant="edit" className="text-xs px-2 py-1" onClick={onEdit}>
            Редактировать
          </Button>
          <Button variant="danger" className="text-xs px-2 py-1" onClick={onDelete}>
            Удалить
          </Button>
        </div>
      </div>
    </div>
  );
}